import {
  Message,
  Session,
  Contact,
  WebSocketMessage,
  ApiResponse,
} from '@peptalk/shared';

// Field types
export type FieldType = 'text' | 'email' | 'tel' | 'textarea' | 'select';

export interface WidgetState {
  isOpen: boolean;
  connectionStatus: 'connecting' | 'connected' | 'disconnected' | 'error';
}

export enum VIEW {
  HOME = 'HOME',
  CHAT = 'CHAT',
}

// Re-export shared types
export type { Message, Session, Contact, WebSocketMessage, ApiResponse };
